import { BrandKitFormInputs } from '../BrandKitForm.types'
import { FormProvider, useForm } from 'react-hook-form'
import { ReactNode } from 'react'

/**
 * Context provider from `react-hook-form` to wrap {@link BrandKitForm}.
 */
export const BrandKitFormProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const formMethods = useForm<BrandKitFormInputs>({
    shouldFocusError: false,
    reValidateMode: 'onChange'
  })
  return <FormProvider {...formMethods}>{children}</FormProvider>
}
